// extracted by mini-css-extract-plugin
module.exports = {"jrLink":"JoyrideLink_jrLink__F5kXN"};